import type { SetStateFn } from '@/Types';
import { passwordResetMutation } from '@/graphql/mutations/Auth.mutation';
import { FormControl, Input, InputLabel } from '@mui/material';
import type React from 'react';
import { toast } from 'react-toastify';

type Props = {
  loading: boolean;
  setLoading: SetStateFn<boolean>;
  onFormSend: () => void;
};

export const ForgotPasswordForm = ({ loading, setLoading, onFormSend }: Props) => {
  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData(e.currentTarget);
    const userLogin = formData.get('user_login') as string;

    passwordResetMutation(
      { input: { username: userLogin } },
      {
        onCompleted: (response, error) => {
          setLoading(false);
          if (error?.length) {
            toast.error(error.map((e) => e.message).join(' '));
            return;
          }
          onFormSend();
        },
      }
    );
  };

  return (
    <form className="loginform form" onSubmit={onSubmit} nonce={window.znRuntime?.cspStrictValue}>
      <FormControl className="login-username">
        <InputLabel htmlFor="user_login">Email or Username</InputLabel>
        <Input id="user_login" type="text" name="user_login" size="small" required autoComplete="off" />
      </FormControl>

      <FormControl className="login-submit" disabled={loading}>
        <Input
          id="wp-submit"
          type="submit"
          name="wp-submit"
          className="button button-primary"
          value="Request New Password"
        />
      </FormControl>
    </form>
  );
};
